package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.TrashOutline: ImageVector
    get() {
        if (_trashOutline != null) {
            return _trashOutline!!
        }
        _trashOutline = Builder(name = "TrashOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 11.0f, viewportHeight = 11.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(2.25f, 10.5f)
                curveTo(1.9292f, 10.5f, 1.6545f, 10.3858f, 1.426f, 10.1573f)
                curveTo(1.1976f, 9.9288f, 1.0833f, 9.6542f, 1.0833f, 9.3333f)
                lineTo(1.0833f, 1.75f)
                lineTo(0.5f, 1.75f)
                lineTo(0.5f, 0.5833f)
                lineTo(3.4167f, 0.5833f)
                lineTo(3.4167f, 0.0f)
                lineTo(6.9167f, 0.0f)
                lineTo(6.9167f, 0.5833f)
                lineTo(9.8333f, 0.5833f)
                lineTo(9.8333f, 1.75f)
                lineTo(9.25f, 1.75f)
                lineTo(9.25f, 9.3333f)
                curveTo(9.25f, 9.6542f, 9.1358f, 9.9288f, 8.9073f, 10.1573f)
                curveTo(8.6788f, 10.3858f, 8.4042f, 10.5f, 8.0833f, 10.5f)
                lineTo(2.25f, 10.5f)
                lineTo(2.25f, 10.5f)
                moveTo(8.0833f, 1.75f)
                lineTo(2.25f, 1.75f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(8.0833f, 9.3333f)
                lineTo(8.0833f, 9.3333f)
                lineTo(8.0833f, 9.3333f)
                lineTo(8.0833f, 1.75f)
                lineTo(8.0833f, 1.75f)
                moveTo(3.4167f, 8.1667f)
                lineTo(4.5833f, 8.1667f)
                lineTo(4.5833f, 2.9167f)
                lineTo(3.4167f, 2.9167f)
                lineTo(3.4167f, 8.1667f)
                lineTo(3.4167f, 8.1667f)
                moveTo(5.75f, 8.1667f)
                lineTo(6.9167f, 8.1667f)
                lineTo(6.9167f, 2.9167f)
                lineTo(5.75f, 2.9167f)
                lineTo(5.75f, 8.1667f)
                lineTo(5.75f, 8.1667f)
                moveTo(2.25f, 1.75f)
                lineTo(2.25f, 1.75f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 9.3333f)
                lineTo(2.25f, 1.75f)
                lineTo(2.25f, 1.75f)
            }
        }
        .build()
        return _trashOutline!!
    }

private var _trashOutline: ImageVector? = null
